// extracted by mini-css-extract-plugin
export default {"cardFormat":"resources-page_cardFormat__YDOFc","cardContainer":"resources-page_cardContainer__vpBcs"};